import { requestOfPut, requestOfGet, requestOfPost } from "../utils/http";
const baseUrl = "wechath5/zh-cn/v1/integralmall";

export function getPointCatalogList(param) {
  return requestOfGet(baseUrl + "/catalog", param);
}
export function getPointGoodsList(param) {
  return requestOfGet(baseUrl + "/goods", param);
}
export function getPointGoodsDatail(id) {
  return requestOfGet(baseUrl + "/goods/" + id);
}
export function submitPointGoodsOrder(param) {
  return requestOfPost(baseUrl + "/exchange", param);
}
